import { Age } from "@common";

import { pink, babyBlue, purple, red, green, gold } from "../config";
import BungeeTTF from "../assets/fonts/Bungee-Regular.ttf";
import DagnyTTF from "../assets/fonts/Dagny.ttf";
import DagnyBoldTTF from "../assets/fonts/DagnyBold.ttf";
import DagnyItalicTTF from "../assets/fonts/DagnyItalic.ttf";
import DagnyBlackTTF from "../assets/fonts/DagnyOffcPro-Black.ttf";
import { PaletteMode } from "@mui/material";

/**
 *
 * Font arrays used across app
 */
export const dagnyFont = [
  "Dagny",
  "-apple-system",
  "BlinkMacSystemFont",
  '"Segoe UI"',
  "Roboto",
  '"Helvetica Neue"',
  "Arial",
  "sans-serif",
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
].join(",");
export const bungeeFont = ["Bungee", "Verdana", "Geneva", "Tahoma", "sans-serif"].join(",");
export const dagnyBlackFont = [
  "DagnyBlack",
  "-apple-system",
  "BlinkMacSystemFont",
  '"Segoe UI"',
  "Roboto",
  '"Helvetica Neue"',
  "Arial",
  "sans-serif",
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
].join(",");

export const getDesignTokens = (mode: PaletteMode) => ({
  palette: {
    mode,
    ...(mode === "light"
      ? {
          primary: {
            main: pink[500],
          },
          secondary: {
            main: purple[500],
          },
          error: {
            main: red[500],
          },
          success: {
            main: green[500],
          },
          neutral: {
            light: babyBlue[500][200],
            main: babyBlue[500][500],
            dark: babyBlue[500][800],
            contrastText: "#000",
          },
          gold: {
            light: gold[200],
            main: gold[500],
            dark: gold[800],
            contrastText: "rgba(0, 0, 0, 0.87)",
          },
          background: {
            default: babyBlue[500],
          },
          text: {
            primary: purple[500],
          },
        }
      : {
          primary: {
            main: pink[500],
          },
          secondary: {
            main: babyBlue[500],
          },
          error: {
            main: red[500],
          },
          success: {
            main: green[500],
          },
          neutral: {
            light: purple[200],
            main: purple[500],
            dark: purple[800],
            contrastText: "#fff",
          },
          gold: {
            light: gold[200],
            main: gold[500],
            dark: gold[800],
            contrastText: "rgba(0, 0, 0, 0.87)",
          },
          background: {
            default: purple[500],
          },
          text: {
            primary: "#ffffff",
          },
        }),
  },
});

/**
 *
 *
 * This theme acts as a global default, directly sent to MUI.
 */
const theme = (age: Age) => {
  return {
    typography: {
      allVariants: {
        fontFamily: dagnyFont,
      },
      h1: {
        fontFamily: dagnyBlackFont,
        letterSpacing: "-0.01rem",
      },
      h2: {
        fontFamily: dagnyBlackFont,
        letterSpacing: "-0.01rem",
      },
      h3: {
        fontFamily: dagnyBlackFont,
        letterSpacing: "-0.01rem",
      },
      h4: {
        fontFamily: dagnyBlackFont,
        letterSpacing: "-0.01rem",
      },
      h5: {
        fontWeight: "bold",
      },
      h6: {
        fontWeight: "bold",
      },
      body1: {
        fontSize: age === "elderly" ? 22 : 19,
        lineHeight: "1.4",
        fontWeight: "normal",
      },
      body2: {
        fontSize: age === "elderly" ? 20 : 17,
        lineHeight: "1.4",
        fontWeight: "normal",
      },
      button: {
        fontSize: age === "elderly" ? 22 : 18,
        textTransform: undefined,
      },
    },
    transitions: {
      duration: {
        shortest: 150,
        shorter: 200,
        short: 250,
        standard: 300,
        complex: 375,
        enteringScreen: 225,
        leavingScreen: 195,
      },
      easing: {
        easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
        easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
        easeIn: "cubic-bezier(0.4, 0, 1, 1)",
        sharp: "cubic-bezier(0.4, 0, 0.6, 1)",
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: `
        html::-webkit-scrollbar {
          display: none;
        }
        html {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        @font-face {
          font-family: "Bungee";
          src: local("Bungee"), url(${BungeeTTF}) format("truetype");
          font-weight: normal;
        }
        @font-face {
          font-family: "Dagny";
          src: local("Dagny"), url(${DagnyTTF}) format("truetype");
          font-weight: normal;
        }
        @font-face {
          font-family: "Dagny";
          src: local("Dagny"), url(${DagnyBoldTTF}) format("truetype");
          font-weight: bold;
        }
        @font-face {
          font-family: "Dagny";
          src: local("Dagny"), url(${DagnyItalicTTF}) format("truetype");
          font-style: italic;
        }
        @font-face {
          font-family: "DagnyBlack";
          src: local("Dagny"), url(${DagnyBlackTTF}) format("truetype");
        }
        .no-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .no-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `,
      },
    },
  };
};
export default theme;
